var exports = {
  "kL": "xfd349460--7de8c6--container",
  "Sl": "xfd349460--7de8c6--image",
  "wm": "xfd349460--7de8c6--logo",
  "ne": "xfd349460--7de8c6--controls",
  "h_": "xfd349460--7de8c6--description",
};

module.exports = exports;
